import * as React from 'react';
import classNames from 'classnames';
import styles from './ScrollCustomStyles.module.scss';

// currently diff between ScrollCustomStyles and ScrollArea, that in ScrollCustomStyles it defines only styles.
// It is more flexible, but not cross-browser solution and is used for case when we can't use ScrollArea due to
// antd specific implementation of components (like Table, Trasnfer etc)

interface ScrollCustomProps {
	isDatepicker?: boolean;
}

export const ScrollCustomStyles: React.FC<ScrollCustomProps> = ({ isDatepicker, ...props }) => {
	return (
		<div
			className={classNames(styles.scrollCustomStyles, {
				datapickerScroll: isDatepicker,
			})}
		>
			{props.children}
		</div>
	);
};

export default ScrollCustomStyles;
